import React, { useEffect, useState, useCallback, Suspense } from 'react';
import LoaderComponent from '@components/atom/layout/loader';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { RootState } from '@reducers/index';

const AppInfo = React.lazy(() => import('@components/template/layout/appInfo/appInfo'));
const Tab = React.lazy(() => import('@components/template/app/featured/tab'));
const FeaturedAppList = React.lazy(() => import('@components/template/app/featured/featuredAppList'));

type Props = {};

const FeaturedApps = (props: Props) => {
  const { selectedAppInfo } = useSelector((state: RootState) => state.LAYOUT);
  const [nowTab, setNowTab] = useState('game');
  const [date, setDate] = useState(moment().format('YYYY-MM-DD'));
  const [featureInfo, setFeatureInfo] = useState(null);

  const featureInfoHandler = useCallback((item) => {
    setFeatureInfo(item);
  }, []);

  const tabHandler = useCallback((item) => {
    setNowTab(item);
  }, []);

  const dateHandler = useCallback((date) => {
    return setDate(moment(date).format('YYYY-MM-DD'));
  }, []);

  return (
    <>
      <div className="app-info">
        <Suspense fallback={<LoaderComponent />}>
          <AppInfo />
        </Suspense>
      </div>
      <Suspense fallback={<LoaderComponent />}>
        <Tab
          selectedAppInfo={selectedAppInfo}
          featureInfoHandler={featureInfoHandler}
          tab={nowTab}
          tabHandler={tabHandler}
          date={date}
          dateHandler={dateHandler}
        />
      </Suspense>
      {featureInfo &&
        featureInfo.map((item) => (
          <Suspense key={item.title} fallback={<LoaderComponent />}>
            <FeaturedAppList info={item} nowTab={nowTab} date={date} />
          </Suspense>
        ))}
    </>
  );
};

export default FeaturedApps;
